
import { CommonModule } from "@angular/common";
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { IPlatformUser } from "@nova/common-interfaces";
import { ButtonModule } from "primeng/button";
import { StepperModule } from "primeng/stepper";
import { AuthenticatedHeaderComponent } from "../../../shared/components/auth/authenticated-header/authenticated-header.component.mjs";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { OrderAddressComponent } from "../../components/address/address.component";
import { OrderInternetPlanComponent } from "../../components/internet-plan/internet-plan.component";
import { OrderReviewComponent } from "../../components/review/review.component";
import { OrderSetupPlanComponent } from "../../components/setup-plan/setup-plan.component";
import { OrderSidebarComponent } from "../../layouts/order-sidebar/order-sidebar.component";
@Component({
  selector: "app-order-dashboard",
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    StepperModule,
    OrderAddressComponent,
    OrderInternetPlanComponent,
    OrderSetupPlanComponent,
    OrderReviewComponent,
    OrderSidebarComponent,
    AuthenticatedHeaderComponent
  ],
  templateUrl: "./order-dashboard.component.html",
  styleUrl: "./order-dashboard.component.scss",
  encapsulation:ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OrderDashboardComponent {
  isToggled = false;
  @Input()
  user: IPlatformUser | undefined;
  @Input() activateCallback!: (step: number) => void;
  handleToggle(newState: boolean) {
    this.isToggled = newState;
  }

  constructor(router: Router, private authService: AuthService) {
    this.authService.user$.subscribe((user) => {
      if (user) {
        this.user = { ...user } as unknown as IPlatformUser;
      }
    });
  }

  goToNextStep() {
    if (this.activateCallback) {
      this.activateCallback(3); // Example usage of the function
    }
  }
}
